import type { EWIActivity } from 'teacher-ui-client/subscription-type/writing-ideas/previews/route'

export const ewiActivityData: EWIActivity = {
  activity_id: 'ewi_001',
  // Real API shape: conforms exactly to the dev API response
  title: 'Teacup Troubles',
  description: '',
  template: 'QW',
  thumbnail: 'owc/activities/users/1117/cup.jpg',
  // tags not returned by this endpoint in the real API, kept here for tag-badge test coverage
  tags: 'Imaginative Texts,Persuasive Texts,Informative Texts,Grade 5',
  blocks: [
    {
      // Real API block order: Image → Exemplar → Attachments
      block_id: 'clbmwne5r1ebw9o3obdmpnthv',
      block_type: 'Image',
      // Legacy format — bare path string (no JSON wrapper), matching the real dev API
      content: 'owc/activities/users/1117/8b0da547ff2447c7fdc49174e75a5cb6 (1).png',
      lexorank: '0|i0000n:',
      target_word_count: 60,
    },
    {
      block_id: 'ck9an8y7i1ebn9o3o6hd68r1x',
      block_type: 'Exemplar',
      content: JSON.stringify({
        // Real Quill HTML from the API: <span> within <p>, &nbsp; entities — DOMParser handles both correctly
        sourceText:
          "<p>Let me tell you about my life as a teacup.&nbsp;Yeah, up here on the shelf.&nbsp;Di<span>d you forget about me?&nbsp;Well, I'm not surprised.&nbsp;No </span>one thinks about a teacup except when it's teatime.&nbsp;Then it's all boiling hot water and plopping in teabags.&nbsp;Did you ever stop to think about how hot that water is?&nbsp;It's a shock every time.</p>" +
          '<p><br></p>' +
          "<p>Some think we're a fragile bunch.&nbsp;In fact, we get blamed for chipping all the time.&nbsp;<span>It's not our fault we get slippery when covered in soap suds, is it?&nbsp;</span>Jeepers, even saucers blame us for spilling on them.&nbsp;And teaspoons are always invading our personal space.&nbsp;We're just asking for a little respect.</p>" +
          '<p><br></p>' +
          "<p><span>That's why we're going on strike.&nbsp;Until people start caring about us, they can have their tea in a glass or even a bowl.&nbsp;</span></p>",
        // Real API also includes mainComment and quiteClose — parsed but unused by the Ember getter
        mainComment: '',
        quiteClose: '',
        annotations: [
          {
            id: 'ab8863af-cb98-4445-9687-edea8f236321',
            tagId: 'c8ae7b9e-7fc3-4c74-a258-8d316a8c4b0c',
            text: 'Conversational tone helps the reader engage with the character.',
            ranges: [{ index: 73, length: 51 }],
          },
          {
            id: '71ad0b99-b83e-422b-854a-04bcc2e500b1',
            tagId: '025e9e4e-a499-4c8b-b0af-61c93ca93060',
            text: 'Questions help the reader relate to the story.',
            ranges: [{ index: 399, length: 69 }],
          },
          {
            id: 'e32b0113-12b3-4da2-9c91-4f2874206b42',
            tagId: 'd1ac0ba2-dd6d-4d6a-89a6-38a35c90e08b',
            text: 'A creative and interesting ending leaves the audience with something to think about.',
            ranges: [{ index: 616, length: 121 }],
          },
        ],
      }),
      question_type: '',
      lexorank: '0|i00013:',
      target_word_count: 60,
    },
    {
      block_id: 'ck9nkhwhb1eby9o3o2uidyrgs',
      block_type: 'Attachments',
      content: JSON.stringify({
        podcast1: { src: 'owc/activities/attachments/activity_1851/1588299463485_JORDAN - Teacup troubles.mp3' },
      }),
      question_type: '',
      lexorank: '0|i0001b:',
      target_word_count: 60,
    },
  ],
}

// ewi_002 — normal (QuickWrite) type: image + audio prompt only, no exemplar
export const ewiNormalActivityData: EWIActivity = {
  activity_id: 'ewi_002',
  title: 'Choosing a Pet',
  description: 'Would you choose a dog or a cat? Use the image prompt to inspire your writing.',
  template: 'QW',
  tags: 'Persuasive Texts,Grade 2',
  blocks: [
    {
      block_id: 'block_attachments_002',
      block_type: 'Attachments',
      content: JSON.stringify({
        podcast1: { src: 'audio/ewi/ewi_002_intro.mp3' },
      }),
      lexorank: 'a',
    },
    {
      block_id: 'block_image_002',
      block_type: 'Image',
      content: JSON.stringify({
        src: 'owc/activities/users/1117/Screen%20Shot%202020-05-25%20at%2010.18.49%20am.png',
        alt: 'A dog and a cat sitting side by side',
      }),
      lexorank: 'b',
    },
  ],
}

export const ewiActivityFixtures: Record<string, EWIActivity> = {
  ewi_001: ewiActivityData,
  ewi_002: ewiNormalActivityData,
}
